import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ak-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  sessionUser: any;
  loading = false;
  env = environment;

  constructor(
    private router: Router,
    private _auth: AuthService
  ) { }

  ngOnInit(): void {
    // Suscribirse a los cambios de autenticación
    this._auth.auth$.subscribe((rep: any) => {
      this.sessionUser = rep ? this._auth.sessionUser : null;
    });
  }

  // Método para obtener la hora actual formateada
  getCurrentTime(): string {
    const now = new Date();
    return now.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

}
